import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import RecruiterMap from "../components/RecruiterMap";

export default function Home() {
  return (
    <>
      <Box
        sx={{
          py: 8,
          background:
            "radial-gradient(60% 80% at 50% 0%, rgba(99,102,241,.12) 0%, transparent 60%)"
        }}
      >
        <Container>
          <Typography variant="h3" fontWeight={700}>Hugo Suire</Typography>
          <Typography variant="h5" sx={{ opacity: 0.8, mt: 1 }}>
            
          </Typography>
          <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
            <Button component={Link} to="/experiences">Mes experiences</Button>
            <Button component={Link} to="/cv" variant="outlined">CV</Button>
          </Stack>
        </Container>
      </Box>

      <Container sx={{ py: 6 }}>
        <Typography variant="h5" gutterBottom>À la manière de Linkedln</Typography>
         <Typography
          variant="body1"
          sx={{ opacity: 0.85, mb: 3, maxWidth: 700 }}
         >
          Pour mieux analyser mes candidatures, j’ai développé cette carte de suivi
          afin de mesurer l’intérêt suscité auprès des recruteurs.
        </Typography>
        <RecruiterMap />
      </Container>
    </>
  );
}
